
import React, { useEffect, useRef } from 'react';
import '../../../assets/css/screens/customer/privacyPolicy/PrivacyPolicy.css'; // External CSS file import
import Topbar from '../../../components/customer/home/topbar/Topbar';
import MyNavbar from '../../../components/customer/home/Navbar/MyNavbar';
import Myfooter from '../../../components/customer/home/footer/Myfooter';
import {
  Database, Eye, Share2, Lock, Trash2, Bell, Globe
} from 'lucide-react';
import ScrollToTop from '../../general/scrolltotop/ScrollToTop';

const SECTIONS = [
  {
    icon: <Database size={20} />,
    title: "Information We Collect",
    text: "When you register on Picks4Tips, we collect information such as your name, email address, phone number, profile details, and other information required to create your account. Responders may also be required to submit KYC documents for identity verification.",
  },
  {
    icon: <Eye size={20} />,
    title: "How We Use Your Information",
    text: "We use your information to create and manage your account, facilitate job postings and service requests, verify Responders, process payments, improve platform functionality, and provide customer support.",
  },
  {
    icon: <Share2 size={20} />,
    title: "Information Sharing",
    text: "We only share information necessary to complete services on the platform. Information may be shared between Seekers and Responders solely for job fulfillment. Payment-related information is securely processed through Stripe. We do not sell your personal information to third parties.",
  },
  {
    icon: <Lock size={20} />,
    title: "Data Security",
    text: "Picks4Tips uses appropriate technical and organizational security measures to protect your personal information from unauthorized access, disclosure, alteration, or misuse. While we strive to keep your information secure, no online platform can guarantee absolute security.",
  },
  {
  icon: <Trash2 size={20} />,
  title: "Account Management",
  text: "Users can securely log out of their Picks4Tips account at any time. If a user wishes to permanently delete their account and associated personal data, they may submit an account deletion request through the platform. Deletion requests are reviewed and processed in accordance with our data management policies and applicable legal requirements.",
},
 {
  icon: <Bell size={20} />,
  title: "Platform Communications",
  text: "Picks4Tips may send important notifications related to your job updates and other KYC status updates to ensure the smooth operation of the platform.",
},
  {
  icon: <Globe size={20} />,
  title: "Third-Party Services",
  text: "Picks4Tips uses trusted third-party services such as Stripe to securely process payouts and payment-related operations. These services handle information in accordance with their own privacy and security policies.",
},
];

const PrivacyPolicy = () => {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = [];
    itemRefs.current.forEach((el) => {
      if (!el) return;
      const obs = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('pp-item--visible');
            obs.disconnect();
          }
        },
        { threshold: 0.15 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach(o => o.disconnect());
  }, []);

  return (
    <>
      <ScrollToTop />
      <Topbar />
      <MyNavbar />
      <div className="pp-page">
        <div className="pp-container">

          {/* Header */}
          <div className="pp-header">
            <h2 className="pp-main-title">Privacy Policy</h2>
            <p className="pp-updated">Last updated: March 2026</p>
            <p className="pp-intro">
              At Picks4Tips, we value your privacy and are committed to protecting your
              personal information. This Privacy Policy explains how we collect, use,
              store, and safeguard your information when you use our platform.
            </p>
          </div>

          {/* Sections */}
          <div className="pp-list">
            {SECTIONS.map((sec, i) => (
              <div
                key={i}
                className="pp-item"
                ref={el => (itemRefs.current[i] = el)}
                style={{ transitionDelay: `${i * 0.07}s` }}
              >
                <div className="pp-item__left">
                  <div className="pp-item__icon">{sec.icon}</div>
                  {i < SECTIONS.length - 1 && <div className="pp-item__line" />}
                </div>

                <div className="pp-item__content">
                  <h5 className="pp-item__title">{sec.title}</h5>
                  <p className="pp-item__text">{sec.text}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
      <Myfooter />
    </>
  );
};

export default PrivacyPolicy;